import { createFileRoute } from "@tanstack/react-router";

import { ConsultaOnline } from "@/components/itv/pages/ConsultaOnline";
import { carregarPaginaSimples } from "@/lib/pagina-simples";

const PATH = "/consulta-online/";
const TITLE = "Teleconsulta com Médico Nutrólogo | Dr. Thiago Viana";
const DESCRIPTION =
  "Teleconsulta de nutrologia para todo o Brasil. Avaliação clínica completa de exames, histórico e rotina, com prescrição médica e acompanhamento seguro.";

export const Route = createFileRoute("/consulta-online")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return <ConsultaOnline />;
}
